module.exports = __webpack_public_path__ + "static/extension-a3675b4711bfd1b57c4fa91a004c27d2.jpg";